import React, { FormEvent, useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import iconSearch from '../images/search-icon-smartsg.svg';
import { ConversationContext } from '../contexts/ConversationContext';
import { backendProxy } from '../hooks/backendProxy';

const UserInputDiv = styled.div`
    display: flex; align-items: center;
`
/*
const VoiceInput = styled.div<{ disabled: boolean }>`
    float: left; width: 54px; height: 54px; border: solid 3px #000; border-radius: 50%; margin-right: 20px;
    @media (max-width: 768px) {
        width: 26px; height: 26px; border: solid 2px #000; border-radius: 50%; margin-right: 15px;
    }
    img {
        color: #000; margin-left: 15px; margin-top: 7px;
        @media (max-width: 768px) {
            width: 12px; margin-left: 7px; margin-top: 3px;
        }
    }
    &.busy {
        pointer-events: none;
        img {opacity: 0.2;}
    }
`*/

const TextInput = styled.div`
    display: flex; flex-flow: column; width: 100%; /*padding-left: 80px;*/
    /*@media (max-width: 768px) {
        padding-left: 0;
    }*/
    .input-label {
        position: relative;
        float: left;
        width: 100%;
        .dots {
            position: absolute;
            left: 34px;
            top: 20px;
            font-size: 24px;
            font-weight: 600;
            color: #000;
        }
    }
    input[type="search"] {
        width: 100%;
        font-weight: 400;
        background-color: #fff;
        outline: none;
        box-shadow: none;
        border-image: none;
        height: 60px;
        float: left;
        border: solid 3px #000;
        border-radius: 40px;
        font-size: 16px;
        -webkit-appearance: none;
        appearance: none;
        padding: 0 80px 0 30px;
        @media (max-width: 768px) {
            padding: 0 50px 0 15px; border: solid 2px #000;
            /*font-size: 14px;*/
        }
        &::-webkit-search-cancel-button {
            -webkit-appearance: none; appearance: none;
        }
    }
    .search-go {
        position: absolute;
        right: 0;
        top: 0;
        color: #000;
        padding: 11px 30px 10px 20px;
        border: none;
        background: none;
        outline: none;
        cursor: pointer;
        @media (max-width: 768px) {
            padding: 19px 18px 19px 18px;
            img {width: 20px;}
        }
        &.empty {
            opacity: 0.2;
        }
    }
    .searchform.busy {
        input[type="search"] {
            pointer-events: none;
        }
        .dots::after {
            content: '';
            animation: dots 1.5s steps(1) infinite;
        }
        .search-go {pointer-events: none; opacity: 0.2;}
    }
    /* Punkt-Animation für die drei Punkte */
    @keyframes dots {
        0% {
            content: '';
        }
        30% {
            content: '.';
        }
        60% {
            content: '..';
        }
        90% {
            content: '...';
        }
    }
`

const loadInitialQuestion = () => {
    const params = new URLSearchParams(window.location.search);
    const q = params.get("q");
    return q ? decodeURIComponent(q): '';
}
export const UserInput: React.FC = () => {
    const [userInput, setUserInput] = useState<string>(loadInitialQuestion());
    const userInputRef = useRef<HTMLInputElement>(null);
    const { conversationState, clientId, addUserMessage, messages } = useContext(ConversationContext);
    const [reselectedMessageId, setReselectedMessageId] = useState<number>();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search); 
        if (params.get("autoRun") === "true" && userInput) {
            params.delete("autoRun");
            onSend();
        }   
    }, []);
    /*
    const onRecordVoice = async () => {
        await backendProxy.trackEvent('record-voice', clientId, { userInput });
        alert("Noch nicht implementiert");
    }*/
    const onSend = async (e?: FormEvent<HTMLFormElement>) => {
        if (e) e.preventDefault();
        await backendProxy.trackEvent('send-message', clientId, { userInput });
        if (userInput) {
            setUserInput("");
            setReselectedMessageId(undefined);
            addUserMessage(userInput);
        }
        return false;
    }

    const onInputChange = (e: FormEvent<HTMLInputElement>) => {
        setUserInput((e.target as HTMLInputElement).value);
    }

    /* TODO Styling:
        - VoiceInput sollte im disabled state auch anders aussehen.
    */

    const isIdle = conversationState === 'idle';
    const searchFormClass = isIdle ? 'searchform' : 'searchform busy'
    const searchButtonClass = !userInput ? 'search-go empty' : 'search-go'
    const placeholder = isIdle ? 'Wie kann ich weiterhelfen?' : ''

    const onKeyUp = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        const userMessages = messages.filter(m => m.role === 'user');
        if (evt.code === "ArrowUp" && (reselectedMessageId === undefined || reselectedMessageId > 0) ) {
            const indexOfUserMessageToReselect = (reselectedMessageId || userMessages.length) - 1;
            setReselectedMessageId(indexOfUserMessageToReselect);
            setUserInput(userMessages[indexOfUserMessageToReselect].content);
        }
        if (evt.code === "ArrowDown" && (reselectedMessageId !== undefined && reselectedMessageId < userMessages.length)) {
            if (reselectedMessageId === (userMessages.length - 1)) {
                setReselectedMessageId(undefined);
                setUserInput("");
            } else {
                const indexOfUserMessageToReselect = reselectedMessageId + 1;
                setReselectedMessageId(indexOfUserMessageToReselect);
                setUserInput(userMessages[indexOfUserMessageToReselect].content);
            }
        }
    }
    useEffect(() => {
        if (userInputRef.current && isIdle) {
            userInputRef.current.focus();
        }
    }, [userInputRef, isIdle])

    return (
        <UserInputDiv>
            { /*
                <VoiceInput disabled={!isIdle} className={voiceInputClass}>
                    <a href="#" onClick={onRecordVoice} title="Spracheingabe"><img src={iconMicrophone} alt="Spracheingabe" /></a>
                </VoiceInput>
             */
             }
            <TextInput>
                <form name="searchFormBox" className={searchFormClass} onSubmit={onSend}>
                    <label className="input-label search-label empty">
                        <span className="dots"></span>
                        <input ref={userInputRef} value={userInput} disabled={!isIdle} onInput={onInputChange} onKeyUp={onKeyUp} autoComplete="off" type="search" className="searchfield" name="searchfield" id="searchfield" placeholder={placeholder} />
                        <button disabled={!userInput} className={searchButtonClass}><img src={iconSearch} alt="Suchen" /></button>
                    </label>
                </form>
            </TextInput>
        </UserInputDiv>
    )
}